<template>
    <div class="appeal-form">
        <div class="title">社区违规申诉</div>
        <div class="form-item">
            <div class="form-item-label">申诉类型</div>
            <div class="form-item-value">
                <VRadioGroup
                    v-model="form.type"
                >
                    <VRadio
                        v-for="typeOption in typeOptions"
                        :key="typeOption.value"
                        :value="typeOption.value"
                        color="#18191C"
                    >
                        {{ typeOption.label }}
                    </VRadio>
                </VRadioGroup>
            </div>
        </div>
        <div class="form-item">
            <div class="form-item-label">{{ urlOptions.label }}</div>
            <div class="form-item-value">
                <VInput
                    v-model="form.url"
                    :placeholder="urlOptions.placeholder"
                />
            </div>
            <div class="form-item-tips">
                <template v-for="t in urlOptions.tips">
                    <p :key="t">{{ t }}</p>
                </template>
            </div>
        </div>
        <div class="form-item">
            <div class="form-item-label">{{ reasonOptions.label }}</div>
            <div class="form-item-value">
                <VInput
                    class="reason-input"
                    v-model="form.reason"
                    type="textarea"
                    maxlength="100"
                    :placeholder="reasonOptions.placeholder"
                    show-word-limit
                />
            </div>
        </div>
        <div class="submit">
            <VButton
                size="large"
                :type="disabled ? 'disabled' : 'primary'"
                @click="handleSubmit"
            >提交</VButton>
            <div class="submit-tips">注：24小时内仅可提交3条{{ form.type === APPEAL_TYPE.REPLY ? '评论' : '动态' }}申诉；申诉结果24小时内会通过 首页-消息中心-系统通知 发送，也请您后续关注~</div>
        </div>
    </div>
</template>

<script>
import { Radio, RadioGroup, Input, Button, Toast, Bxios, Login } from '@bplus-common/components-vue2'
import BiliUser from '@bilibili/bili-user'

const APPEAL_TYPE = {
    REPLY: 1,
    OPUS: 2,
}
export default {
    components: {
        VButton: Button,
        VInput: Input,
        VRadio: Radio,
        VRadioGroup: RadioGroup,
    },
    data() {
        return {
            APPEAL_TYPE,
            userInfo: null,
            form: {
                type: 1,
                url: '',
                reason: '',
            },
            typeOptions: [
                {
                    label: '评论申诉',
                    value: APPEAL_TYPE.REPLY,
                },
                {
                    label: '图文动态申诉',
                    value: APPEAL_TYPE.OPUS,
                },
            ],
            reasonOptions: {
                label: '申诉理由',
                placeholder: '请填写申诉理由 （10～100字）'
            },
        }
    },
    computed: {
        urlOptions() {
            if (this.form.type === APPEAL_TYPE.REPLY) return {
                label: '所在稿件BV号或位置链接',
                placeholder: '请输入稿件bv号或位置链接',
                tips: [
                    '1、视频bv号您可在视频标题下方简介长按复制',
                    '2、若没有bv号，您也可在app内右上角三点-复制链接或在pc复制网址',
                    // '     样例链接格式：https://b23.tv/xxxxxxx（注意链接中需去除文字信息）',
                ]
            }
            return {
                label: '申诉动态id或链接',
                placeholder: '请输入申诉动态id或链接',
                tips: [
                    '1、动态id您可在动态违规消息通知复制',
                    '2、动态链接app侧您可使用  右上角三点-复制链接；pc侧从地址栏复制',
                ]
            }
        },
        errorMsg() {
            if (!this.form.url) {
                return this.urlOptions.placeholder
            }
            if (!this.form.reason || this.form.reason.length < 10 || this.form.reason.length > 100) return this.reasonOptions.placeholder
            return ''
        },
        disabled() {
            return !!this.errorMsg
        }
    },
    async created() {
        try {
            const { code, data } = await BiliUser.get()
            if (code === 0) {
                this.userInfo = data
            }
        } catch {
            Toast('请先登录')
        }
    },
    methods: {
        async handleSubmit() {
            try {
                switch (await Login()) {
                    case 'LOGINED':
                    case 'SUCCESS':
                        break
                    case 'CANCEL':
                        return
                    }
            } catch (error) {
                Toast(error.message)
                return
            }
            if (this.disabled) {
                Toast(this.errorMsg)
                return
            }

            if (this.form.type === APPEAL_TYPE.REPLY) {
                const data = {
                    type: 1,
                    reason: this.form.reason
                }
                
                if (new RegExp('(BV|bv|Bv|bV)1[1-9A-NP-Za-km-z]{9}$').test(this.form.url)) {
                    data.oid = this.form.url
                } else {
                    // other
                    let url = this.form.url
                    const opusId = url.match(/bilibili.com\/opus\/(\d+)/)?.[1] || ''
                    if (opusId) {
                        url = `https://t.bilibili.com/${opusId}`
                    }
                    data.url = url
                }
                try {
                    const { success_toast: succToast } = await Bxios({
                        method: 'POST',
                        url: '/x/v2/reply/appeal/submit',
                        baseURL: Bxios.BASE_URL.API,
                        data,
                        csrf: {
                            data: true,
                        },
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                    })
                    Toast(succToast)
                    this.form.url = ''
                    this.form.reason = ''
                } catch (err) {
                    Toast(err.message || '')
                }
                return
            }

            try {
                const data = {
                    uid: this.userInfo.mid,
                    link: this.form.url,
                    reason: this.form.reason,
                }
                const { toast: succToast } = await Bxios({
                    method: 'POST',
                    url: '/x/dynamic/feed/dyn/appeal',
                    baseURL: Bxios.BASE_URL.API,
                    data,
                    csrf: {
                        data: true,
                    },
                })
                Toast(succToast)
                this.form.url = ''
                this.form.reason = ''
            } catch (err) {
                let errMsg = ''
                switch (err.code) {
                    case 56601:
                        errMsg = '申诉提交已达当日上限'
                        break
                    case 56602: 
                        errMsg = '您已提交过该申诉'
                        break
                    default:
                        errMsg = err.data?.toast || err.message || '网络错误，请稍后再试'
                        break
                }
                Toast(errMsg)
            }
        },
    },
    
}
</script>

<style lang="less">
.appeal-form {
    padding-top: 30px;
    padding-bottom: 60px;
    width: 420px;
    margin: 0 auto;
    .title {
        font-weight: 700;
        font-size: 22px;
        line-height: 34px;
        text-align: center;
    }
    .form-item {
        margin-top: 30px;
        &-label {
            font-weight: 700;
            font-size: 16px;
            line-height: 22px;
        }
        &-value {
            margin-top: 10px;
        }
        &-tips {
            margin-top: 10px;
            font-size: 12px;
            line-height: 17px;
            color: #9499A0;
            p:not(:first-child) {
                margin-top: 2px;
                white-space: break-spaces;
            }
        }
        .reason-input .bili-input__inner {
            height: 126px;
        }
    }
    .submit {
        margin-top: 42px;
        width: 100%;
        .bili-button {
            width: 100%;
        }
        &-tips {
            margin-top: 12px;
            font-size: 12px;
            line-height: 17px;
            color: #9499A0;
        }
    }
    .bili-input {
        &::before {
            content: none;
        }
        border: 1px solid #E3E5E7;
        transition: border-color .2s;
        &:hover {
            border-color: #00a1d6;
        }
    }
}
</style>